import { CustomerInterface } from '../interfaces/customer';
import { CustomerEmailRow } from '../utils/customerEmails';

export class Customer implements CustomerInterface {
    IDCustomer?: number;
    CreationDate: Date | null;
    Enabled: boolean;
    CompanyName: string;
    VATNumber: string;
    FiscalCode: string;
    LegalForm: string;
    AtecoCode: string;
    ChamberOfCommerce: string;
    REANumber: string;
    RegistrationDate: Date | null;
    VisuraDate: Date | null;
    Employees: string;
    HeadOffice: string;
    HeadOfficeProvince: string;
    Address: string;
    HouseNumber: string;
    IBAN: string;
    SupportBankName: string;
    SupportBankBIC: string;
    SDICode: string;
    PEC: string;
    ULALastBalance: string;
    SalesRevenues: string;
    TotalAssets: string;
    BalanceDate: Date | null;
    Email: string;
    emails?: CustomerEmailRow[];
    Phone: string;
    MobilePhone: string;
    Name: string;
    Surname: string;
    BirthPlace: string;
    BirthPlaceProvince: string;
    BirthDate: Date | null;
    City: string;
    Province: string;
    /** Calcolati dal backend in GET /customer/all: non sono colonne della tabella. */
    RequestsCount?: number;
    CompletedRequestsCount?: number;

    constructor() {
        this.CreationDate = null;
        this.Enabled = true;
        this.CompanyName = '';
        this.VATNumber = '';
        this.FiscalCode = '';
        this.LegalForm = '';
        this.AtecoCode = '';
        this.ChamberOfCommerce = '';
        this.REANumber = '';
        this.RegistrationDate = null;
        this.VisuraDate = null;
        this.Employees = '';
        this.HeadOffice = '';
        this.HeadOfficeProvince = '';
        this.Address = '';
        this.HouseNumber = '';
        this.IBAN = '';
        this.SupportBankName = '';
        this.SupportBankBIC = '';
        this.SDICode = '';
        this.PEC = '';
        this.ULALastBalance = '';
        this.SalesRevenues = '';
        this.TotalAssets = '';
        this.BalanceDate = null;
        this.Email = '';
        this.Phone = '';
        this.MobilePhone = '';
        this.Name = '';
        this.Surname = '';
        this.BirthPlace = '';
        this.BirthPlaceProvince = '';
        this.BirthDate = null;
        this.City = '';
        this.Province = '';
    }
}
